
import { Observable,
         BehaviorSubject,
         ReplaySubject,
         firstValueFrom,
         throwError } from 'rxjs'

import { debounceTime,
         distinctUntilChanged,
         tap,
         catchError, 
         take} from 'rxjs/operators'

import { Inject, Injectable } from '@angular/core';
// import { AUTH_CONFIG } from '../_models/auth-config.ts';
import { Router } from '@angular/router';

import { HttpClient,
         HttpHeaders,
         HttpParams,
         HttpErrorResponse } from '@angular/common/http';

// import { AuthInterceptorService } from './auth-interceptor.service'
import { CookieService } from './cookie.service'
import { TokenService } from './token.service'


import { SocialAuthService,
         GoogleLoginProvider,
         SocialUser } from '@abacritt/angularx-social-login'

import { User } from '../_models/user.model'

import { ApiService } from './api.service'
// import { UserService } from '../../_core/_services/user.service';


// lcp-token

// const ACCESS_TOKEN_KEY: string = 'lcp_access_token_token'
// const REFRESH_TOKEN_KEY: string = 'lcp_refresh_token'

// const OAUTH_CLIENT = 'express-client';
// const OAUTH_SECRET = 'express-secret';

import { APP_BASE_HREF } from '@angular/common';
import { environment } from 'src/environments/environment'
import { UserService } from './user.service';
// import { UserService } from '..';


// const API_URL_NGX = 'http://localhost:8080/api/v1/'; //http://localhost:3001/v1/'; // 'http://localhost:8080/api/v1/'; // 



@Injectable()
export class AuthService {

  redirectUrl = ''
  // isPopulated = false
  logoutTimeout: any

  private isPopulatedSubject = new BehaviorSubject<boolean>(false)
  public isPopulated = this.isPopulatedSubject.asObservable().pipe(debounceTime(10), distinctUntilChanged())
  private isPopulatedLocal: boolean // User
  
  // private currentUserSubject = new BehaviorSubject<any>(null)
  // public currentUser = this.currentUserSubject.asObservable().pipe(debounceTime(10), distinctUntilChanged())
  // private currentUserLocal: any // User

  private currentUserSubject = new ReplaySubject<User>(1)
  public currentUser = this.currentUserSubject.asObservable().pipe(debounceTime(10), distinctUntilChanged())
  private currentUserLocal: User

  private loginMessageSubject = new ReplaySubject<string>(1)
  public loginMessage = this.loginMessageSubject.asObservable().pipe(distinctUntilChanged())

  private returnPathSubject = new BehaviorSubject<string>('home')
  public returnPath = this.returnPathSubject.asObservable().pipe(distinctUntilChanged())

  private pendingEmailSubject = new ReplaySubject<string>(1)
  public pendingEmail = this.pendingEmailSubject.asObservable().pipe(distinctUntilChanged())


  private static handleError(error: HttpErrorResponse): any {
    if (error.error instanceof ErrorEvent) {
      console.error('An error occurred:', error.error.message);
    } else {
      console.error(
        `Backend returned code ${error.status}, ` +
        `body was: ${error.error}`);
    }
    return throwError(() => 'Something bad happened; please try again later.');
  }

  // private static log(message: string): any {
  //   console.log(message);
  // }

  constructor(
    @Inject(APP_BASE_HREF) public baseHref: string,
    public router: Router,
    private apiService: ApiService,
    // private authInterceptorService: AuthInterceptorService,
    private cookieService: CookieService,
    private socialAuthService: SocialAuthService,
    private tokenService: TokenService,
    private userService: UserService,
    private http: HttpClient,
    // private socialAuthService: SocialAuthService
  ) {}

  public static HTTP_OPTIONS = {
    headers: new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      Authorization: 'Basic ' + btoa(environment.google_client_id + ':' + environment.google_client_secret)
    })
  }

  apiUrl() {
    // console.log('apiUrl', this.baseHref, window.location, window.location.href.split(this.baseHref)[0])
    // return window.location.href.split(this.baseHref)[0] + '/oak-park/api/v1/'
    return window.location.href.split(this.baseHref)[0] + '/api/v1/'
  }

  // httpOptions() {
  //   // let accessToken = // cookie.lcp_access_token

  //   return {
  //     headers: new HttpHeaders({
  //       'Content-Type': 'application/x-www-form-urlencoded',
  //       Authorization: 'Basic ' + btoa(OAUTH_CLIENT + ':' + OAUTH_SECRET)
  //     })
  //   }
  // }

  updateLoginMessage(message: string, delay = 100) {
    window.setTimeout(this.updateLoginMessageNow.bind(this, message), delay)
  }
  updateLoginMessageNow(message: string) { this.loginMessageSubject.next(message) }

  updateReturnUrl(url: string, delay?: number) {
    // console.log('uru', url)
    if (!delay) return this.returnPathSubject.next(url)
    window.setTimeout(this.updateReturnUrl.bind(this, url), delay)
  }

  updatePendingEmail(email: string) {
    this.pendingEmailSubject.next(email)
  }


  // https://www.djamware.com/post/5f8f99673b3daf2033c40cac/angular-10-tutorial-oauth2-login-and-refresh-token
  // https://www.djamware.com/post/5f808519b9ebd3190382a52f/rest-api-security-with-node-express-postgresql-oauth2


  login(params: any): Observable<any> {
    // console.log('LOGIN', params)
    this.tokenService.removeToken()
    this.tokenService.removeRefreshToken()

    const body = new HttpParams()
      .set('email', params.email)
      .set('password', params.password)
      .set('grant_type', 'password');

    let url = this.apiUrl() + 'auth/login' // 'oauth/token'
    // console.log('LOGIN POST', url, body, params, AuthService.HTTP_OPTIONS)

    return this.http.post<any>(url, body, AuthService.HTTP_OPTIONS)
      .pipe(
        tap(res => {     
          // console.log('TODO: refresh token, within jwt?')
          // this.tokenService.saveRefreshToken(res[this.tokenService.refreshTokenKey])
          // let token = res[this.tokenService.accessTokenKey]
          this.updateTokenFromTokenResponse(res)
        }),
        catchError(err => {
          // console.log('login error', err)
          AuthService.handleError(err)
          return Promise.reject(err)
        })
      );
  }

  loginSocial(socialUser: SocialUser): Observable<any> {
    // console.log('TODO: loginSocial 1', socialUser)

    this.tokenService.removeToken()
    this.tokenService.removeRefreshToken()
    
    const body = new HttpParams()
      .set('socialData', JSON.stringify(socialUser))
    //   .set('password', params.password)
    //   .set('grant_type', 'password');

    let url = this.apiUrl() + 'auth/login/social' // 'oauth/token'
    
    // console.log('loginSocial...', url, body, AuthService.HTTP_OPTIONS)
    // let body = {}

    return this.http.post<any>(url, body, AuthService.HTTP_OPTIONS)
      .pipe(
        tap(res => {     
          // console.log('TODO: loginSocial 2', res, res[this.tokenService.accessTokenKey]) 
          return this.updateTokenFromTokenResponse(res)
        }),
        catchError(AuthService.handleError)
      )
    // console.log('res', res)
    // return Promise.resolve(res)
  }

  updateTokenFromTokenResponse(res: any) {
    let token = res[this.tokenService.accessTokenKey] // googleTokenKey
    // console.log('utftr', res, token)
    return this.updateToken(token)
  }

  socialLogin(provider='google') {
    if (provider != 'google') return console.log('ERR: socialLogin provider', provider)
  }


  async logout(redirectHome = false): Promise<any> {
    // console.log('LOGOUT')
    this.tokenService.removeToken()
    this.tokenService.removeRefreshToken()
    this.updateToken(null)
    this.updateCurrentUser(null)
    this.socialAuthService.signOut()

    if (this.logoutTimeout) window.clearTimeout(this.logoutTimeout)
    if (redirectHome) return this.router.navigate([''])
    return Promise.resolve()
    // this.cookieService.delete('local', this.tokenService.accessTokenKey)
    // this.cookieService.delete('local', this.tokenService.refreshTokenKey)
  }

  register(data: any): Observable<any> {
    return this.http.post<any>(this.apiUrl() + 'oauth/signup', data)
      .pipe<any, any>(
        tap(_ => console.log('register')),
        catchError(AuthService.handleError)
      );
  }

  secured(): Observable<any> {
    return this.http.get<any>(this.apiUrl() + 'secret')
      .pipe(catchError(AuthService.handleError));
  }

  HttpBearerOptions(token): any {
    return {
      headers: new HttpHeaders({
        // 'Content-Type': 'application/json',
        Authorization: 'Bearer ' + token
      })
    }
  }


  updateIsPopulated(isPopulated: boolean) {
    this.isPopulatedSubject.next(isPopulated)
    this.isPopulatedLocal = isPopulated
  }

    // check cookie with server & load user's info.
  // This runs once on application startup.
  populateAuth(force = false): Promise<User|void> {
    // prevent unless all cookies approved... ?
    // console.log('populateAuth', this.isPopulatedLocal)

    // prevent db hit if already populated
    if (this.isPopulatedLocal === true && !force) {
      // return this.populateAuthdAlready()
      // console.log('populated!', this.getCurrentUser())
      return this.getCurrentUser()
    }

    let token = this.cookieService.get('local', 'lcp_access_token')

    this.updateToken(token)

    if (!token || !this.passCookieConsentCheck()) return this.populateAuthLoggedOut()

    // let token = res[this.tokenService.accessTokenKey]
    // this.tokenService.saveToken(token)

    // JWT detected; attempt to get & store user's info
    return firstValueFrom(this.apiService.get('auth/status')).then((user:User) => {
        // console.log('STATUS', user, user.hasOwnProperty('id'))
        // console.log('TODO: countdown', this.jwtService.decode(token))
        user = user as User

        if (this.isPopulatedLocal === true && !force) return this.getCurrentUser()
        if (user.hasOwnProperty('id')) return this.populateAuthWithUser(user)
        return this.populateAuthLoggedOut()
      }).catch(err => {
        console.warn('auth/current ERR', err)
        return this.populateAuthLoggedOut()
      })
  }
  
  updateToken(token): Promise<any> {
    this.tokenService.updateToken(token)
    // console.log('PARSE?', token)
    let data = this.tokenService.parseToken(token)
    let email = data && data['email']
    // console.log('>>> updateToken DATA', data, token)
    if (!email) return this.handleNoEmail(data) 

    this.beginLogoutTimeoutFromTokenData(data)

    return this.populateAuthFromEmail(email)
  }

  handleNoEmail(data?): Promise<any> {
    // console.log('ERR: login - no email returned', data)
    return Promise.resolve() 
  }

  beginLogoutTimeoutFromTokenData(data) {
    let exp = data && data['exp']
    let diffMs =  (exp * 1000) - Date.now()
    this.logoutTimeout = window.setTimeout(() => {
      // console.log('LOGOUT') 
      this.logout() 
    }, diffMs)
  }

  populateAuthLoggedOut(): Promise<User|void> {
    // Remove any potential remnants of previous auth states
    // console.log('LOGGED OUT') 
    this.authPurge()
    this.updateIsPopulated(true)
    return Promise.resolve(null)
  }

  async populateAuthFromEmail(email:string): Promise<User> {
    // this.cookieService.set('local', 'lcp_access_token', email) // user.auth_token)
    let user = await this.userService.findUserBy({ email: email })
    if (!user) {
      console.log('ERR: populateAuthFromEmail !user ', email)
      return Promise.resolve(null)
    }

    return this.populateAuthWithUser(user)
  }

  populateAuthWithUser(user: User): Promise<User> {
    // console.log('populateAuthWithUser', user)
    this.updateIsPopulated(true)

    // Set current user data into observable
    this.updateCurrentUser(user)
    return Promise.resolve(user)
  }

  passCookieConsentCheck(): boolean {
    let cookieConsent = this.cookieService.getCookieConsent()
    // console.log('CHECK cookieConsent', cookieConsent)
    if (!cookieConsent) return false
    return cookieConsent.hasAttribute('necessary')
  }

  authPurge() {
    this.updateCurrentUser(null)
    // this.authResetSubjects()
    // console.log('AUTH PURGE')
    this.cookieService.delete('local','lcp_access_token')
    // window.setTimeout(this.cookieServiceLog.bind(this), 1000)
  }

  updateCurrentUser(user: User) {
    // console.log('UCU', user)
    let u = !!user ? new User(user) : null
    this.currentUserSubject.next(u)
    this.currentUserLocal = u
    // console.log('UCU', user, u, this.currentUserLocal)
    // this.currentUser.pipe(take(1)).subscribe(
    //   { next: (value) => { console.log('CURRENT USER First value:', value) },
    //     error: (error) => { console.error('Error:', error) },
    //     complete: () => { console.log('Subscription completed') } }
    // )
  }

  getCurrentUser(): Promise<User|any> {
    // return current user if populated (null if logged out)
    // console.log('getCurrentUser', this.isPopulatedLocal, this.currentUserLocal)

    if (this.isPopulatedLocal) return Promise.resolve(this.currentUserLocal)

    return firstValueFrom(this.currentUser.pipe(take(1)))
  }

  // awaits 'isPopulated' then returns currentUser if any
  // from: https://codepen.io/anon/pen/jzpZMa?editors=0011
  currentUserPing(): Promise<User|any> {
    const isPopulatedPing = () => {
      let interval = 1000
      return new Promise(resolve => setTimeout(() => resolve(this.isPopulated), interval))
    }
    // const isPopulated = this.isPopulatedPing
    const currentUserLoop = async value => {
      let isPopulated = null
      while(isPopulated !== true) isPopulated = await isPopulatedPing()
      return Promise.resolve(this.currentUserLocal)
    }
    console.log('CHECK currentUserPing', currentUserLoop)
    return Promise.resolve(currentUserLoop(this.isPopulatedLocal))
  }

  getSocialUserDetails(socialUser: SocialUser): Observable<any> {
    let idToken = socialUser && socialUser.idToken
    let url = idToken && `https://www.googleapis.com/oauth2/v3/tokeninfo?id_token=${idToken}`
    return this.http.get<any>(url)
      .pipe(catchError(AuthService.handleError))
  }
}